import { useContext } from "react";
import {
  DataFormat,
  DataFormatFilters,
  DataFormatFiltersTranslator,
  dataFormatsConstants,
  DataFormatSortingOptionsConsts,
} from "../../../api/DataFormats";
import { NotSet } from "../../misc/UIconstants";
import { EntitySidebarTile, EntitySidebarTileProps } from "./EntitySidebarTile/EntitySidebarTile";
import { SessionContext } from "../../contexts/SessionContext";
import { getIndexRoute } from "../../../main/Routing";

export const DataFormatsTile = (props: EntitySidebarTileProps<DataFormat, DataFormatFilters>) => {
  const { route } = useContext(SessionContext);
  return (
    <EntitySidebarTile<DataFormat, DataFormatFilters>
      {...props}
      entityConstants={dataFormatsConstants}
      orderByOptions={DataFormatSortingOptionsConsts}
      translatorConsts={DataFormatFiltersTranslator}
      defaultFilters={{ sortBy: [{ property: "NAME", sortDirection: "ASC" }], ...props.defaultFilters }}
      rowLabel={(e) => <>{e.name}</>}
      rowDate={(e) => <>{e.vendors?.map((vendor) => vendor.name) ?? NotSet}</>}
      rowInfo={(e) => <>{e.methods?.map((method) => method.name) ?? NotSet}</>}
      linkTo={() => route(getIndexRoute(dataFormatsConstants.frontendIndexRoute))}
    />
  );
};
